import './App.css';
import {Component} from 'react';
import Restaurant from './Card.js';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import logo from './YW8.png';

const example = {
  "restuarants": [
    {
      "location": {
        "lat": 47.657851,
        "lng": -122.313492
      },
      "name": "Big Time Brewery & Alehouse",
      "photos": {
        "height": 1675,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/106188553415577799882\">Big Time Brewery &amp; Alehouse</a>"
        ],
        "photo_reference": "Aap_uEBQK9dxXZycuZH7iLPw8tjgzDV6ZOkRI7s-fFLT982PkkUc66Pham3elXYdagLW3hKjBFCtROjdj0Kyf40efzWMBobYVcoIqTI8Wy0Da3yUp_wmTDrbnPfcb5wMvC285VLEQuS7PT5Z3FM1X5jREaV4iRHev7WP92oiXwmecHZqLdjr",
        "width": 2976
      },
      "place_id": "ChIJKaC2QvMUkFQRWVvn71SBmuY",
      "wait_time": 29,
      "walk_time": 5.616666666666666
    },
    {
      "location": {
        "lat": 47.6592399,
        "lng": -122.3134023
      },
      "name": "Chipotle Mexican Grill",
      "photos": {
        "height": 1360,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/118068216436250370737\">최용수</a>"
        ],
        "photo_reference": "Aap_uEDBehKN1ofud3epgmisFFJZ9tkibaAcojRlgVxhNcJxpDLePifucQAh_aCiiODuy1Jp3cC7jApH09KIZwSQgT7dUlZsq_ZKbXcvbTu17rweqg_lQvCND9-7vHtpsXMG0X7XqHaLUpjHHHip1QPxJJ6YNqD-71Ry4KepOk9ZebJjewY1",
        "width": 2048
      },
      "place_id": "ChIJ9yhJrvQUkFQRbsWNMgL3lhE",
      "wait_time": 100,
      "walk_time": 5
    },
    {
      "location": {
        "lat": 47.6574076,
        "lng": -122.312937
      },
      "name": "Cafe Solstice",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/105475619114224847075\">Andrey Kurenkov</a>"
        ],
        "photo_reference": "Aap_uEDw1x4Q_CN6VjzhlJHcmzFdX21bFp5AAtPSrOt6hBc34XgygsHHZyC2uwQW8DVnWquR_kvb6KdfxPy7M24eeiY_hbAdR9-MsLGNw6P5YwT6ZXxRJKLkBbt4zSUbex6lOIBJsvGUy78sY38ecpjv8MRN8dNdaC_6U_DwL22N6iBb9UO0",
        "width": 4032
      },
      "place_id": "ChIJaZE6QvMUkFQRXCfaq6_QnBE",
      "wait_time": 38,
      "walk_time": 6.05
    },
    {
      "location": {
        "lat": 47.65466319999999,
        "lng": -122.3215434
      },
      "name": "Voula's Offshore Cafe",
      "photos": {
        "height": 3008,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/107692004417798737010\">Blake Coleman</a>"
        ],
        "photo_reference": "Aap_uEAgtb-b-t5M9cUs-Xm34R9OWitoFjxMlJUqhMxqo2NQKndJSxJmLf-tkAhfDbyhI_zdOpQUmPQUEQS2JwAZNU-ztNYJN6Z6amQ48v_cQz3YN1XoM2czkydc7vA-KMpeRyhkiKCkv0q2sB9TPc_1DRSnUY7-hQ1z_YsKeBQwuM7k5JXb",
        "width": 4000
      },
      "place_id": "ChIJ_6PM3vAUkFQRKmNERgd3N8M",
      "wait_time": 66,
      "walk_time": 17.783333333333335
    },
    {
      "location": {
        "lat": 47.6677401,
        "lng": -122.3004006
      },
      "name": "McDonald's",
      "photos": {
        "height": 1080,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/110464100161873627786\">Mason Lim</a>"
        ],
        "photo_reference": "Aap_uEB3nc1lnk-RO20UhcfIWGZmB0tBnuzNuB7kzhBu-M46oZJVcEpC7BN1syztaQJvPGNrPsOFQVh2Iayf6AVTZgQVx0FiulF0MvS9AoyXs048TWBnHy7hB2JCbkSewZuJxQKer4z2ntWc533T8OlFC5V62d7pNJlRMZy0XF20BjDN0eXl",
        "width": 1920
      },
      "place_id": "ChIJreTBgIcUkFQRKh_jcEGENNY",
      "wait_time": 85,
      "walk_time": 19.8
    },
    {
      "location": {
        "lat": 47.6610617,
        "lng": -122.3277773
      },
      "name": "Dick's Drive-In",
      "photos": {
        "height": 2268,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/106918879336789003556\">Curtis Dady</a>"
        ],
        "photo_reference": "Aap_uEAk-bYuB9D0PycbR-I7zUKdlNUF06JUGOcesqXrZaK5tt19M3RJ23ZxRasbWQ5niOIdLAgQP2Bev4IGIfckCFuSOs7MsWKikKtD3DQgNt4tq1Y8saZ0xu845t4Fm6pekg1xqiFanTq6T-UsWN9Di5wYhI95L4ESwT6jFUrrc42MCyT3",
        "width": 4032
      },
      "place_id": "ChIJd5TY51gUkFQRU_h3DzLnCi4",
      "wait_time": 45,
      "walk_time": 22.066666666666666
    },
    {
      "location": {
        "lat": 47.65822,
        "lng": -122.313383
      },
      "name": "Starbucks",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/107056712198401068597\">Mark Konings</a>"
        ],
        "photo_reference": "Aap_uED5a9JGoQML8rEKqLQCs_cQUEA16gXyjPUIzbCc6NBg-TUCUPk7eKvnut897TGzSCznLc-KkrSEbTEIDNb5zPphCZtJGFPcJ6AKbXYILUeqnVFImxedKCGUmSFmvkC870tGGB1p_-4vztmrATFli9D7ZtWApMnwSxcjNp1Yv6QNV7eT",
        "width": 4032
      },
      "place_id": "ChIJm2i9WPMUkFQRQ8B_XnsrsTc",
      "wait_time": 37,
      "walk_time": 5.2
    },
    {
      "location": {
        "lat": 47.66903800000001,
        "lng": -122.3175972
      },
      "name": "Taste of India",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/107056712198401068597\">Mark Konings</a>"
        ],
        "photo_reference": "Aap_uECSORz3mbuq-raJNeWzCnEPu19KbUEzXsADVaWE5-5x89sf0DmRXiyzSv6Z1gWNYxuCKwDISOQ429ucXcTqvcyqfh_suw3oXn_xYebSOuvBImoPkpSX_7lDV0HsMXJ3WTT4Wq3t7cgiYZ75-7CPWks-7nzmndZhuDJB1uu3Iatp_Cqw",
        "width": 4032
      },
      "place_id": "ChIJQ0ZVvGYUkFQRbxmrTWKeLCg",
      "wait_time": 19,
      "walk_time": 22.183333333333334
    },
    {
      "location": {
        "lat": 47.66472649999999,
        "lng": -122.3145372
      },
      "name": "Cedars in University District",
      "photos": {
        "height": 3265,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/104428431325386940933\">Cedars in University District</a>"
        ],
        "photo_reference": "Aap_uEA9ll9D3J_4y_RhMkk28GrGX1FYSXDihKP8zLxnw9tLlAXtiA9msOBgaAg9ze-uVamquuCVD6fNqqc_tE0gEYUQevesB66vdRJGF-WxrUAQ6UZ1X2WvEni851Mj8-Tsze48PO5G6JzxkvazUrsWqNEjytO1KldtIsg81ICQ1g3sAdiO",
        "width": 4898
      },
      "place_id": "ChIJwVbit2EUkFQRbDZRK7pQSkk",
      "wait_time": 18,
      "walk_time": 13.033333333333333
    },
    {
      "location": {
        "lat": 47.6547347,
        "lng": -122.3213918
      },
      "name": "Northlake Tavern & Pizza House",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/111383413209720241842\">Jeff Stensland</a>"
        ],
        "photo_reference": "Aap_uEBdQWM_bVYjc9zGSCPO5jrl9wji_hpjA75lUYKEYdJwkiE6qoCzOccRtY9q6HJYh-N-ZgxNjC6r-sAkWv6uITzqRdP-3vYopj44DWaI0OcsGDs7QId1Ih7V0BALkJKOx67rQ58zBbl5akE3zcRek0_CnlOOmorQDGBKWqhd4AoSQXJg",
        "width": 4032
      },
      "place_id": "ChIJfUK_IPEUkFQR4u43oRHlUZw",
      "wait_time": 1,
      "walk_time": 17.966666666666665
    },
    {
      "location": {
        "lat": 47.66288,
        "lng": -122.298581
      },
      "name": "Veggie Grill",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/107056712198401068597\">Mark Konings</a>"
        ],
        "photo_reference": "Aap_uECVaSl2oUsv-upbufWYW5l47XSwxt3-G9kdP5SVYCRRoHdgQ1cMtcVU-Ks-nm5OfUvkc-TobzhqH2eezmZr4AkLBef92hyLjTuWe2zyxvwxPvJUVCZP3xVBVLU1N4DkVyYoipHyabX79En2kCyadXPDIY7pmcEGA6K6F4KTfssCf6UI",
        "width": 4032
      },
      "place_id": "ChIJo6Dh_4UUkFQRv4deKp03S6w",
      "wait_time": 3,
      "walk_time": 15.983333333333333
    },
    {
      "location": {
        "lat": 47.6622167,
        "lng": -122.2979556
      },
      "name": "Piatti",
      "photos": {
        "height": 3760,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/116964334333891411595\">Piatti</a>"
        ],
        "photo_reference": "Aap_uEC3FH3FpKne72m84GdjjHHSGpysxLPKLTF4cQo9bRzic_zAp2rvQ3fxrk67khCeqi8eQH-2O363BGEDcHHuCliBtRk37iTbuT0B1GtkukfOy20GlAgBE3A9wTNKSBPTv2XoMa8bdZXdH0iST8Yu-p9OATODhPQP8iFM1OFktbFkmy6U",
        "width": 5640
      },
      "place_id": "ChIJy7wT-IUUkFQR_p6A7eS0SZU",
      "wait_time": 62,
      "walk_time": 16.35
    },
    {
      "location": {
        "lat": 47.6584338,
        "lng": -122.3124845
      },
      "name": "MOD Pizza",
      "photos": {
        "height": 1291,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/109062152188489752309\">Eric C</a>"
        ],
        "photo_reference": "Aap_uED-31aH-hjng4GXMCNPYDLBJzferqimTUbKCTOMXLJdIqRAL-qOZP14gGQRz4a1vikjdm0IHjWPvUwCANlGCHEZFFJ6tBJhovfEhFUkpIvOzPodLat22WVeaJozIUu_P9HK-58qhiszT0fdfMkEVQxDkZEnIS9WVUIGj1kJdc2rD1kK",
        "width": 2000
      },
      "place_id": "ChIJbROKVPMUkFQRIxq3W7CzQ58",
      "wait_time": 66,
      "walk_time": 4.816666666666666
    },
    {
      "location": {
        "lat": 47.6617673,
        "lng": -122.3134034
      },
      "name": "U:Don Fresh Japanese Noodle Station - University District",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/102380632612941871237\">Andrew Tsai</a>"
        ],
        "photo_reference": "Aap_uEAQYkJJkRezVNslsvYyCtQFa2POIGbplw7vSqtsWjcn0RDcgHPiLvVwVShROJiIHCyMb7ZQM6QkdMgfW7KS2X9niQ3JEIcWgki-CTdP95oWfJcEHmklxJFwDqDuwCOtMgt-mEHjzxiFHHO6HjI-Op0nt1Yk59McvZriCEx0RNfILWjl",
        "width": 4032
      },
      "place_id": "ChIJu8FM74oUkFQRTIfGPPZ2xqI",
      "wait_time": 11,
      "walk_time": 7.516666666666667
    },
    {
      "location": {
        "lat": 47.669085,
        "lng": -122.313308
      },
      "name": "Persepolis Grill",
      "photos": {
        "height": 3024,
        "html_attributions": [
          "<a href=\"https://maps.google.com/maps/contrib/107825819938232564830\">Persepolis Grill</a>"
        ],
        "photo_reference": "Aap_uEBmGEefmhz1fyMylxvRnelwvYW4gwOdv3MVJtc9VkxsjAETN1SuchAJmwkAh8oz4XbD5ZI4RNPOiiyMmIJzF8iwT7nVbxmj_uZMf1hoio49iWHKLJXjQbbzZC7WKUewch5zoLqCUTaw_DXqGEtVd5EamG9_n6kRzRwnpa9i-ZCKprzV",
        "width": 4032
      },
      "place_id": "ChIJreHIi2MUkFQRmLuDRShRH0I",
      "wait_time": 2,
      "walk_time": 18.066666666666666
    }
  ],
  "objects": [
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJKaC2QvMUkFQRWVvn71SBmuY",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.657851,
              "lng": -122.313492
            },
            "name": "Big Time Brewery & Alehouse",
            "photos": {
              "height": 1675,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/106188553415577799882\">Big Time Brewery &amp; Alehouse</a>"
              ],
              "photo_reference": "Aap_uEBQK9dxXZycuZH7iLPw8tjgzDV6ZOkRI7s-fFLT982PkkUc66Pham3elXYdagLW3hKjBFCtROjdj0Kyf40efzWMBobYVcoIqTI8Wy0Da3yUp_wmTDrbnPfcb5wMvC285VLEQuS7PT5Z3FM1X5jREaV4iRHev7WP92oiXwmecHZqLdjr",
              "width": 2976
            },
            "place_id": "ChIJKaC2QvMUkFQRWVvn71SBmuY",
            "wait_time": 29,
            "walk_time": 5.616666666666666
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJ9yhJrvQUkFQRbsWNMgL3lhE",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6592399,
              "lng": -122.3134023
            },
            "name": "Chipotle Mexican Grill",
            "photos": {
              "height": 1360,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/118068216436250370737\">최용수</a>"
              ],
              "photo_reference": "Aap_uEDBehKN1ofud3epgmisFFJZ9tkibaAcojRlgVxhNcJxpDLePifucQAh_aCiiODuy1Jp3cC7jApH09KIZwSQgT7dUlZsq_ZKbXcvbTu17rweqg_lQvCND9-7vHtpsXMG0X7XqHaLUpjHHHip1QPxJJ6YNqD-71Ry4KepOk9ZebJjewY1",
              "width": 2048
            },
            "place_id": "ChIJ9yhJrvQUkFQRbsWNMgL3lhE",
            "wait_time": 100,
            "walk_time": 5
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJaZE6QvMUkFQRXCfaq6_QnBE",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6574076,
              "lng": -122.312937
            },
            "name": "Cafe Solstice",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/105475619114224847075\">Andrey Kurenkov</a>"
              ],
              "photo_reference": "Aap_uEDw1x4Q_CN6VjzhlJHcmzFdX21bFp5AAtPSrOt6hBc34XgygsHHZyC2uwQW8DVnWquR_kvb6KdfxPy7M24eeiY_hbAdR9-MsLGNw6P5YwT6ZXxRJKLkBbt4zSUbex6lOIBJsvGUy78sY38ecpjv8MRN8dNdaC_6U_DwL22N6iBb9UO0",
              "width": 4032
            },
            "place_id": "ChIJaZE6QvMUkFQRXCfaq6_QnBE",
            "wait_time": 38,
            "walk_time": 6.05
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJ_6PM3vAUkFQRKmNERgd3N8M",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.65466319999999,
              "lng": -122.3215434
            },
            "name": "Voula's Offshore Cafe",
            "photos": {
              "height": 3008,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/107692004417798737010\">Blake Coleman</a>"
              ],
              "photo_reference": "Aap_uEAgtb-b-t5M9cUs-Xm34R9OWitoFjxMlJUqhMxqo2NQKndJSxJmLf-tkAhfDbyhI_zdOpQUmPQUEQS2JwAZNU-ztNYJN6Z6amQ48v_cQz3YN1XoM2czkydc7vA-KMpeRyhkiKCkv0q2sB9TPc_1DRSnUY7-hQ1z_YsKeBQwuM7k5JXb",
              "width": 4000
            },
            "place_id": "ChIJ_6PM3vAUkFQRKmNERgd3N8M",
            "wait_time": 66,
            "walk_time": 17.783333333333335
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJreTBgIcUkFQRKh_jcEGENNY",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6677401,
              "lng": -122.3004006
            },
            "name": "McDonald's",
            "photos": {
              "height": 1080,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/110464100161873627786\">Mason Lim</a>"
              ],
              "photo_reference": "Aap_uEB3nc1lnk-RO20UhcfIWGZmB0tBnuzNuB7kzhBu-M46oZJVcEpC7BN1syztaQJvPGNrPsOFQVh2Iayf6AVTZgQVx0FiulF0MvS9AoyXs048TWBnHy7hB2JCbkSewZuJxQKer4z2ntWc533T8OlFC5V62d7pNJlRMZy0XF20BjDN0eXl",
              "width": 1920
            },
            "place_id": "ChIJreTBgIcUkFQRKh_jcEGENNY",
            "wait_time": 85,
            "walk_time": 19.8
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJd5TY51gUkFQRU_h3DzLnCi4",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6610617,
              "lng": -122.3277773
            },
            "name": "Dick's Drive-In",
            "photos": {
              "height": 2268,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/106918879336789003556\">Curtis Dady</a>"
              ],
              "photo_reference": "Aap_uEAk-bYuB9D0PycbR-I7zUKdlNUF06JUGOcesqXrZaK5tt19M3RJ23ZxRasbWQ5niOIdLAgQP2Bev4IGIfckCFuSOs7MsWKikKtD3DQgNt4tq1Y8saZ0xu845t4Fm6pekg1xqiFanTq6T-UsWN9Di5wYhI95L4ESwT6jFUrrc42MCyT3",
              "width": 4032
            },
            "place_id": "ChIJd5TY51gUkFQRU_h3DzLnCi4",
            "wait_time": 45,
            "walk_time": 22.066666666666666
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJm2i9WPMUkFQRQ8B_XnsrsTc",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.65822,
              "lng": -122.313383
            },
            "name": "Starbucks",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/107056712198401068597\">Mark Konings</a>"
              ],
              "photo_reference": "Aap_uED5a9JGoQML8rEKqLQCs_cQUEA16gXyjPUIzbCc6NBg-TUCUPk7eKvnut897TGzSCznLc-KkrSEbTEIDNb5zPphCZtJGFPcJ6AKbXYILUeqnVFImxedKCGUmSFmvkC870tGGB1p_-4vztmrATFli9D7ZtWApMnwSxcjNp1Yv6QNV7eT",
              "width": 4032
            },
            "place_id": "ChIJm2i9WPMUkFQRQ8B_XnsrsTc",
            "wait_time": 37,
            "walk_time": 5.2
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJQ0ZVvGYUkFQRbxmrTWKeLCg",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.66903800000001,
              "lng": -122.3175972
            },
            "name": "Taste of India",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/107056712198401068597\">Mark Konings</a>"
              ],
              "photo_reference": "Aap_uECSORz3mbuq-raJNeWzCnEPu19KbUEzXsADVaWE5-5x89sf0DmRXiyzSv6Z1gWNYxuCKwDISOQ429ucXcTqvcyqfh_suw3oXn_xYebSOuvBImoPkpSX_7lDV0HsMXJ3WTT4Wq3t7cgiYZ75-7CPWks-7nzmndZhuDJB1uu3Iatp_Cqw",
              "width": 4032
            },
            "place_id": "ChIJQ0ZVvGYUkFQRbxmrTWKeLCg",
            "wait_time": 19,
            "walk_time": 22.183333333333334
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJwVbit2EUkFQRbDZRK7pQSkk",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.66472649999999,
              "lng": -122.3145372
            },
            "name": "Cedars in University District",
            "photos": {
              "height": 3265,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/104428431325386940933\">Cedars in University District</a>"
              ],
              "photo_reference": "Aap_uEA9ll9D3J_4y_RhMkk28GrGX1FYSXDihKP8zLxnw9tLlAXtiA9msOBgaAg9ze-uVamquuCVD6fNqqc_tE0gEYUQevesB66vdRJGF-WxrUAQ6UZ1X2WvEni851Mj8-Tsze48PO5G6JzxkvazUrsWqNEjytO1KldtIsg81ICQ1g3sAdiO",
              "width": 4898
            },
            "place_id": "ChIJwVbit2EUkFQRbDZRK7pQSkk",
            "wait_time": 18,
            "walk_time": 13.033333333333333
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJfUK_IPEUkFQR4u43oRHlUZw",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6547347,
              "lng": -122.3213918
            },
            "name": "Northlake Tavern & Pizza House",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/111383413209720241842\">Jeff Stensland</a>"
              ],
              "photo_reference": "Aap_uEBdQWM_bVYjc9zGSCPO5jrl9wji_hpjA75lUYKEYdJwkiE6qoCzOccRtY9q6HJYh-N-ZgxNjC6r-sAkWv6uITzqRdP-3vYopj44DWaI0OcsGDs7QId1Ih7V0BALkJKOx67rQ58zBbl5akE3zcRek0_CnlOOmorQDGBKWqhd4AoSQXJg",
              "width": 4032
            },
            "place_id": "ChIJfUK_IPEUkFQR4u43oRHlUZw",
            "wait_time": 1,
            "walk_time": 17.966666666666665
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJo6Dh_4UUkFQRv4deKp03S6w",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.66288,
              "lng": -122.298581
            },
            "name": "Veggie Grill",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/107056712198401068597\">Mark Konings</a>"
              ],
              "photo_reference": "Aap_uECVaSl2oUsv-upbufWYW5l47XSwxt3-G9kdP5SVYCRRoHdgQ1cMtcVU-Ks-nm5OfUvkc-TobzhqH2eezmZr4AkLBef92hyLjTuWe2zyxvwxPvJUVCZP3xVBVLU1N4DkVyYoipHyabX79En2kCyadXPDIY7pmcEGA6K6F4KTfssCf6UI",
              "width": 4032
            },
            "place_id": "ChIJo6Dh_4UUkFQRv4deKp03S6w",
            "wait_time": 3,
            "walk_time": 15.983333333333333
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJy7wT-IUUkFQR_p6A7eS0SZU",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6622167,
              "lng": -122.2979556
            },
            "name": "Piatti",
            "photos": {
              "height": 3760,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/116964334333891411595\">Piatti</a>"
              ],
              "photo_reference": "Aap_uEC3FH3FpKne72m84GdjjHHSGpysxLPKLTF4cQo9bRzic_zAp2rvQ3fxrk67khCeqi8eQH-2O363BGEDcHHuCliBtRk37iTbuT0B1GtkukfOy20GlAgBE3A9wTNKSBPTv2XoMa8bdZXdH0iST8Yu-p9OATODhPQP8iFM1OFktbFkmy6U",
              "width": 5640
            },
            "place_id": "ChIJy7wT-IUUkFQR_p6A7eS0SZU",
            "wait_time": 62,
            "walk_time": 16.35
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJbROKVPMUkFQRIxq3W7CzQ58",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6584338,
              "lng": -122.3124845
            },
            "name": "MOD Pizza",
            "photos": {
              "height": 1291,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/109062152188489752309\">Eric C</a>"
              ],
              "photo_reference": "Aap_uED-31aH-hjng4GXMCNPYDLBJzferqimTUbKCTOMXLJdIqRAL-qOZP14gGQRz4a1vikjdm0IHjWPvUwCANlGCHEZFFJ6tBJhovfEhFUkpIvOzPodLat22WVeaJozIUu_P9HK-58qhiszT0fdfMkEVQxDkZEnIS9WVUIGj1kJdc2rD1kK",
              "width": 2000
            },
            "place_id": "ChIJbROKVPMUkFQRIxq3W7CzQ58",
            "wait_time": 66,
            "walk_time": 4.816666666666666
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJu8FM74oUkFQRTIfGPPZ2xqI",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.6617673,
              "lng": -122.3134034
            },
            "name": "U:Don Fresh Japanese Noodle Station - University District",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/102380632612941871237\">Andrew Tsai</a>"
              ],
              "photo_reference": "Aap_uEAQYkJJkRezVNslsvYyCtQFa2POIGbplw7vSqtsWjcn0RDcgHPiLvVwVShROJiIHCyMb7ZQM6QkdMgfW7KS2X9niQ3JEIcWgki-CTdP95oWfJcEHmklxJFwDqDuwCOtMgt-mEHjzxiFHHO6HjI-Op0nt1Yk59McvZriCEx0RNfILWjl",
              "width": 4032
            },
            "place_id": "ChIJu8FM74oUkFQRTIfGPPZ2xqI",
            "wait_time": 11,
            "walk_time": 7.516666666666667
          }
        }
      },
      "_owner": null,
      "_store": {}
    },
    {
      "type": {
        "propTypes": {}
      },
      "key": "ChIJreHIi2MUkFQRmLuDRShRH0I",
      "ref": null,
      "props": {
        "props": {
          "data": {
            "location": {
              "lat": 47.669085,
              "lng": -122.313308
            },
            "name": "Persepolis Grill",
            "photos": {
              "height": 3024,
              "html_attributions": [
                "<a href=\"https://maps.google.com/maps/contrib/107825819938232564830\">Persepolis Grill</a>"
              ],
              "photo_reference": "Aap_uEBmGEefmhz1fyMylxvRnelwvYW4gwOdv3MVJtc9VkxsjAETN1SuchAJmwkAh8oz4XbD5ZI4RNPOiiyMmIJzF8iwT7nVbxmj_uZMf1hoio49iWHKLJXjQbbzZC7WKUewch5zoLqCUTaw_DXqGEtVd5EamG9_n6kRzRwnpa9i-ZCKprzV",
              "width": 4032
            },
            "place_id": "ChIJreHIi2MUkFQRmLuDRShRH0I",
            "wait_time": 2,
            "walk_time": 18.066666666666666
          }
        }
      },
      "_owner": null,
      "_store": {}
    }
  ],
  "lat": 47.659163611705544,
  "lng": -122.30875092683881
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      restuarants: [],
      objects: [],
      lat: 47.658101130283974,
      lng: -122.31845242186691
    };
    this.state = example;

  }

  componentDidMount() {
    // Simple GET request using fetch
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.setState({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });


        // const url = "https://128.208.1.135:5000/data?lat=" + this.state.lat + "&lng=" + this.state.lng;

        // fetch(url)
        //   .then(response => response.json())
        //   .then(data => {
        //     console.log(data);
        //     this.setState({restuarants: data});
        //     // this.setState({objects: []});
        //     let objects = [];
        //     data.forEach(element => {
        //       const location = <Card props={{data: element}} key={element.place_id}/>;
        //       objects.push(location);
        //     });
        //     this.setState({objects: objects});
        //     console.log(this.state)
        //   });
        // console.log("loaded")
        // console.log(this.state);

      });
    }

   }

  componentDidUpdate() {
    console.log("update")
  }

  render() {
    console.log("render")
    let itemList = [];
    const data = this.state.restuarants;
    for (let i = 0; i < this.state.restuarants.length; i++) {
      itemList.push(<Restaurant props={data[i]} key={i}/>);
    }
    return (
      <div className="App">
        <Card sx={{ maxWidth: 400 }} className="header">     
            <CardContent className="card-content">
            <img className="logo" src={logo} alt=""/>
              <Typography variant="h5" component="div">
                  Explore Food
              </Typography>
            </CardContent>          
          </Card>
        {itemList}
      </div>
    );
  }
}


export default App;
